module.exports = __webpack_public_path__ + "media/button-animations.0fd90fa1.mp4";